import { render, staticRenderFns } from "./home-type4.vue?vue&type=template&id=6206a6dd&scoped=true"
import script from "./home-type4.vue?vue&type=script&lang=js"
export * from "./home-type4.vue?vue&type=script&lang=js"
import style0 from "./home-type4.vue?vue&type=style&index=0&id=6206a6dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6206a6dd",
  null
  
)

export default component.exports